import JsonResource from "@/types/interfaces/JsonResource";

export default class PostVatNumberPayload implements JsonResource {
  public contractId: string;
  public vatNumber: string;

  constructor(contractId: string, vatNumber: string) {
    this.contractId = contractId;
    this.vatNumber = vatNumber;
  }

  toJsonObject(): Record<string, unknown> {
    return {
      contract_id: this.contractId,
      vat_number: this.vatNumber
    };
  }

  toJsonString(): string {
    return JSON.stringify(this.toJsonObject());
  }
}
